@if (showSharepointLink()) {
  <div class="link-item" *transloco="let t">
    <a [href]="sharepointUrl()" target="_blank" rel="noopener noreferrer">
      {{ t('organizations.detailPage.riskAnalysisDeliveryTab.sections.linkToSharepoint') }}
    </a>
  </div>
}

@if (isEscalated()) {
  <div class="b-reminder">
    <aml-icon class="b-reminder-icon" [iconName]="IconNameMap.triangleExclamation" [size]="IconSizeMap.lg" />
    <span class="b-reminder-date">{{ deliveryTracker().updatedAt | localizedDate }}</span>
    <span class="b-reminder-text">{{ reminder() }}</span>
  </div>
}
<nz-steps [nzCurrent]="currentStepNumber()" [nzProgressDot]="dotTemplate" nzSize="small">
  @for (deliveryTrackerStep of deliveryTrackerSteps(); track deliveryTrackerStep.stepNumber) {
    <nz-step [nzTitle]="stepTitle" />
    <ng-template #stepTitle>
      <span
        class="step-title"
        [class.step-title-active]="currentStepNumber() === deliveryTrackerStep.stepNumber"
        [class.step-title-inactive]="currentStepNumber() !== deliveryTrackerStep.stepNumber"
      >
        {{ deliveryTrackerStep.statusTranslation }}
      </span>
    </ng-template>
  }
</nz-steps>
<ng-template #dotTemplate let-dot let-index="index">
  <span [nz-tooltip]="deliveryTrackerSteps()[index].tooltip" nzTooltipPlacement="top">
    <ng-template [ngTemplateOutlet]="dot" />
  </span>
</ng-template>
